module.exports = __webpack_public_path__ + "img/jiaoyu_gaoxinyizhong_suoluetu.45ae01fd.png";